import { Route } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';

/**
 * Pobiera ustawienia z filtrami po statusie
 *
 * @export
 * @param {Route} route
 * @returns
 */
export function getFiltersSetting(route: Route) {
  if (route.query.statusId) {
    return store
      .dispatch('setting/findPublicWithDefault', {
        code: PublicSettings.FILTERS,
        entityType: EntityType.STATUS,
        entityId: route.query.statusId.toString(),
        throwOnEmpty: true,
        noDelete: true
      })
      .then(setting => (setting?.value ? setting : getFiltersProcedureSetting(route)))
      .catch(err => getFiltersProcedureSetting(route));
  }

  return getFiltersProcedureSetting(route);
}

/**
 * Pobiera ustawienia z filtrami po procedurze
 *
 * @param {Route} route
 * @returns {Promise<any>}
 */
function getFiltersProcedureSetting(route: Route): Promise<any> {
  return store.dispatch('setting/findPublicWithDefault', {
    code: PublicSettings.FILTERS,
    entityId: route.params.procedureId.toString(),
    entityType: EntityType.PROCEDURE
  });
}
